import { render, staticRenderFns } from "./FooterCardsGrid.vue?vue&type=template&id=51f32e5a"
import script from "./FooterCardsGrid.vue?vue&type=script&lang=js"
export * from "./FooterCardsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports